import { Component, computed, inject } from '@angular/core'
import { AnchorComponent, ButtonComponent, EmptyStateComponent } from '@ftr/foundation'
import { queryParam } from '@ftr/routing-paths'
import { WindowRefService } from '@ftr/window'

@Component({
  selector: 'ftr-link-filter',
  templateUrl: './link-filter.component.html',
  styleUrl: './link-filter.component.css',
  imports: [EmptyStateComponent, AnchorComponent, ButtonComponent],
})
export class LinkFilterComponent {
  private readonly windowRefService = inject(WindowRefService)

  private readonly url = queryParam<string | undefined>('u')

  protected readonly parsedUrl = computed(() => {
    const url = this.url()
    if (!url) {
      return undefined
    }
    try {
      const parsed = new URL(url)
      return ['http:', 'https:'].includes(parsed.protocol) ? parsed : undefined
    } catch {
      return undefined
    }
  })

  protected cancel(): void {
    this.windowRefService.nativeWindow().close()
  }
}
